import React, { useState } from 'react';
import CollapsibleSection from './CollapsibleSection';
import PromptInput from '../CreateSidebar/PromptInput';

const ReColorSection = ({
  color,
  setColor,
  colorRefImage,
  handleColorRefUpload,
  prompt,
  setPrompt,
  isOpen,
  onToggle,
  sectionId,
}) => {
  const [isRephrasing, setIsRephrasing] = useState(false);
  const [isRephraseClicked, setIsRephraseClicked] = useState(false);
  const [isPromptImageSelectorOpen, setIsPromptImageSelectorOpen] = useState(false);
  const [hexInput, setHexInput] = useState(color);

  // Sync hexInput with color prop
  React.useEffect(() => {
    setHexInput(color);
  }, [color]);

  // Helper to validate hex color
  const isValidHex = hex => /^#[0-9A-Fa-f]{6}$/.test(hex);

  return (
    <CollapsibleSection 
      title={
        <span>
          Re-Color 
          <span style={{ fontSize: '0.75rem', color: '#888', fontWeight: 'normal' }}> (coming soon) </span>
          
        </span>
      }
      isOpen={false}
      onToggle={onToggle}
      sectionId={sectionId}
    >
      <div>
        <div style={{ marginBottom: '1rem' }}>
          <div style={{ fontWeight: 500, marginBottom: 6, fontSize: '0.875rem' }}>Select Color</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ 
              width: 40, 
              height: 40, 
              backgroundColor: color, 
              borderRadius: 8, 
              border: '2px solid #ddd',
              cursor: 'pointer'
            }} />
            <input
              type="color"
              value={color}
              onChange={e => {
                setColor(e.target.value);
                setHexInput(e.target.value);
              }}
              style={{
                width: 40,
                height: 40,
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer'
              }}
            />
            <input
              type="text"
              value={hexInput}
              onChange={e => {
                const val = e.target.value;
                setHexInput(val);
                if (isValidHex(val)) {
                  setColor(val);
                }
              }}
              maxLength={7}
              style={{
                border: isValidHex(hexInput) ? 'none' : '1.5px solid #f55',
                borderRadius: 12,
                background: 'none',
                color: '#222',
                fontSize: '0.875rem',
                padding: '0.375rem 0.75rem',
                width: 120,
                fontWeight: 500,
                boxShadow: '0 1px 4px rgba(88,80,236,0.06)'
              }}
            />
          </div>
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <div style={{ fontWeight: 500, marginBottom: 6, fontSize: '0.875rem' }}>Upload Color Reference Image (Optional)</div>
          <label style={{ display: 'block', border: '1.5px dashed #bbb', borderRadius: 12, padding: '1rem', textAlign: 'center', cursor: 'pointer', color: '#8850ec' }}>
            <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleColorRefUpload} />
            {colorRefImage ? (
              <img src={colorRefImage} alt="Color Reference" style={{ maxWidth: '100%', maxHeight: 60, borderRadius: 8 }} />
            ) : (
              <span style={{ fontSize: 24 }}>🖼️<span style={{ fontSize: 14, display: 'block', marginTop: 6 }}>Add Image</span></span>
            )}
          </label>
        </div>
        <div>
          <div style={{ fontWeight: 500, marginBottom: 6, fontSize: '0.875rem' }}>Prompt</div>
          <PromptInput
            productPrompt=""
            refImagePrompt=""
            prompt={prompt}
            setPrompt={setPrompt}
            isRephrasing={isRephrasing}
            setIsRephrasing={setIsRephrasing}
            setIsPromptImageSelectorOpen={setIsPromptImageSelectorOpen}
            setIsRephraseClicked={setIsRephraseClicked}
            promptPlaceholder="Just describe with text the change in the Image."
            repharseAllowed={false}
          />
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default ReColorSection; 